<template>
    <section class="totalcarat&quanity">
        <div v-if="props?.boxValue === 'diamWeight'">
            <div class="title_block">
            <div v-if="props?.boxValue === 'diamWeight'">
                <h3 class="mb-0 font-active">{{ title || 'Total Carat Weight' }} : 
                    <span>{{newgreenitem.includes('ct. tw.') ? newgreenitem : newgreenitem + ' ct. tw.'}}</span>
                </h3>
          
            </div>
            <div v-if="props?.boxValue === 'accWeight'">
                <h3 class="mb-0 font-active">{{ title }} : 
                    <span>{{newgreenitem.includes('ct. tw.') ? newgreenitem : newgreenitem + ' ct. tw.'}}</span>
                </h3>
            </div>                                    
        </div>
        <div class="mt-3">
            <div v-if="props?.boxValue === 'diamWeight'">
                <div class="image_block my-3 text-center">
                    <img src="/settingactive/totalctwt.svg" width="150" height="72">

                    <p class="mb-0 title" >{{newgreenitem.includes('ct. tw.') ? newgreenitem : newgreenitem + ' ct. tw.'}}</p>
                </div>
            </div>
            <div v-if="props?.boxValue === 'accWeight'">
                <div class="image_block my-3 text-center">
                    <img src="/settingactive/totalctwt.svg" width="150" height="72">

                    <p class="mb-0 title" >{{newgreenitem.includes('ct. tw.') ? newgreenitem : newgreenitem + ' ct. tw.'}}</p>
                </div>
            </div>
            <!-- COMMON THROUGHT OUT -->
            <p class="mb-0" v-if="props?.boxValue === 'diamWeight'">
                Fancy Diamond carat weight refers to the total carat weight of all the fancy-colored diamonds featured in a {{ $t('jewelry') }} piece.
            </p>
            <p class="mb-0" v-if="props?.boxValue === 'accWeight'">
                Total carat weight refers to the total carat weight of all the diamonds featured in a  {{ $t('jewelry') }} piece.
            </p>
        </div>
        </div>
        <div v-if="props?.boxValue === 'diamQuantity'">
            <div class="">
                <div class="title_block">
                    <h3 class="mb-0 font-active" v-if="props?.boxValue === 'diamQuantity'">
                        {{ title || 'Fancy Diamond Quantity & Shape' }}
                    </h3>
        
                    <h3 class="mb-0 font-active">{{ title }}
                        <span>{{ newgreenitem }}</span>
                    </h3>
                </div>
                <div class="mt-3">
                    
                    <div class="image_block text-center my-3">
                        <div v-if="item?.side_color_stone_shape !== ''">
                            <img width="100" height="72" :src="item?.side_color_stone_shape 
                                ? '/settingactive/' + lowercase(item?.side_color_stone_shape) + '.svg' 
                                : '/public/loose_setting/diamond.svg'" alt="Style"/>
                        </div>
                        <div v-if="item?.center_color_stone_shape !== ''">
                            <img width="100" height="72"  :src="item?.center_color_stone_shape 
                                    ? '/settingactive/' + lowercase(item?.center_color_stone_shape) + '.svg' 
                                    : '/public/loose_setting/diamond.svg'" alt="Style"/>
                        </div>
                    </div>

                    <p class="text-center">
                        <div v-if="props?.boxValue === 'diamQuantity'">
                            Quantity : <b>{{ item?.center_color_stone_num_lots }}</b><br />
                            Shape : <b>{{ item?.center_color_stone_shape }}</b>
                        </div>
                        <div v-else>
                            Quantity : <b>{{ item?.side_color_stone_num_lots }}</b><br />
                            Shape : <b>{{ item?.side_color_stone_shape }}</b>
                        </div>
                        </p>
                        <div class="diamondquanity"v-if="props?.boxValue === 'diamQuantity'">
                            <p class="mb-0" >
                                Fancy diamond quantity refers to the total number of fancy-colored diamonds in a {{ $t('jewelry') }} piece.
                            </p>
                            <p class="mt-1 mb-0 text" v-if="$country.is_india">
                                *Shown as per ring size IN 14. The number of accent diamonds may vary according to the selected ring size.
                            </p>

                            <p class="mt-1 mb-0 text" v-if="!$country.is_india">
                                *Shown as per ring size US 7. The number of accent diamonds may vary according to the selected ring size.
                            </p>
                        </div>
                        <div v-else>
                            <p class="mb-0">Fancy accent diamond quantity refers to the total number of fancy-colored accent diamonds in a {{ $t('jewelry') }} piece
                            </p>
                        </div>
                </div>
            </div>
        </div>


        <div v-if="props?.boxValue === 'accQuantity'">
            <div>
                <div class="title_block">

                    <h3 class="mb-0 font-active">{{ title || 'Diamond Quantity & Shape'  }}
                        <span>{{ newgreenitem }}</span>
                    </h3>
                </div>

                <div class="image_block text-center my-3">
                    <div v-if="item?.side_color_stone_shape">

                        <img width="100" height="72" :src="'/settingactive/' + lowercase(item?.side_color_stone_shape) + '.svg'" alt="Style"/>
                    </div>
                    <div v-if="item?.center_color_stone_shape">
                        <img width="100" height="72" :src="'/settingactive/' + lowercase(item?.center_color_stone_shape) + '.svg'" alt="Style"/>
                        
                    </div>
                </div>
                <p class="text-center">
                    <div v-if="props?.boxValue === 'accQuantity'">
                        Quantity : <b>{{ item?.side_color_stone_num_lots }}</b><br />
                        Shape : <b>{{ item?.side_color_stone_shape }}</b>
                    </div>
                    <div v-else>
                        Quantity : <b>{{ item?.center_color_stone_num_lots }}</b><br />
                        Shape : <b>{{ item?.center_color_stone_shape }}</b>
                    </div>
                    
                    </p>

                    <p class="mb-0">Fancy accent diamond quantity refers to the total number of fancy-colored accent diamonds in a {{ $t('jewelry') }} piece
                    </p>
            </div>

        </div>

        <div class="" v-if="props?.boxValue === 'accWeight'">
            <div class="title_block">
                <h3 class="mb-0 font-active">Total Carat Weight :
                    <span>{{ newgreenitem && newgreenitem.includes('ct. tw.') ? newgreenitem : (newgreenitem ?
                        newgreenitem + ' ct. tw.' : '') }}</span>
                </h3>

            </div>

            <div class="mt-3">
                <div class="image_block my-3 text-center">
                    <img src="/settingactive/totalctwt.svg" width="150" height="72">

                    <p class="mb-0 title">{{ newgreenitem?.includes('ct. tw.') ? newgreenitem : newgreenitem + ' ct. tw.'}}
                    </p>
                </div>
                <p class="mb-0">
                    Total accent diamond carat weight refers to the total carat weight of the fancy-colored accent diamonds featured in a {{ $t('jewelry') }} piece.
                </p>
            </div>


        </div>
    </section>
</template>


<script setup>
   const props = defineProps(['boxValue','title','totalcarat','greenitem','item', 'detailData'])
    // console.log(props, 'quantity');
    const newgreenitem = computed(() => {
        if (props.boxValue === 'diamWeight') {
            return props.item?.center_color_stone_lot_weight || '';
        } else if (props.boxValue === 'accWeight') {
            return props.item?.side_color_stone_lot_weight || '';
        }
  return ''; // Default value
});
const { $country } = useNuxtApp()
const lowercase = (value) => {
		return value.toLowerCase().replace(/[^\w]/gi, '');
	};



const imageNames = ref([]);

const processSideStoneShapes = () => {
    const shapeString = props.item?.center_color_stone_shape || props.item?.center_color_stone_shape || '';
    imageNames.value = shapeString
        .toLowerCase()                  // Convert to lowercase
        .replace(/\s+/g, '')            // Remove all spaces
        .split(',')                     // Split by comma
        .map(name => name.trim());      // Trim each part
};


onMounted(() => {
    processSideStoneShapes();
});
</script>



<style scoped>
.text {
    font-size: 14px;
    font-style: italic;
    color: #909090;
}

.largesvg {
    transform: scale(1.3);
}

.img_box {
    height: 130px;
}

.pop_open {
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

p {
    font-size: 16px;
    color: #606060;
}

.title_block span {
    cursor: pointer;
}

.m-info {
    margin: 10px 0;
}

h3 {
    font-size: 20px;
}

p {
    font-size: 16px;
    color: #606060;
}

.title_block span {
    cursor: pointer;
    color: var(--green);
}
.title{
    color: var(--green);
}
h3 {
    font-size: 22px;
}
.m-info {
    margin: 10px 0;
}


@media(max-width: 767px) {
    h3 {
        font-size: 20px;
    }

    p {
        font-size: 14px;
    }

    .text {
        font-size: 12px;
    }
}
</style>
